import { a as __assign } from './_tslib-4c7d6ae2.js';
import { c as colors } from './colors-23c56846.js';
import { t as typography } from './typography-6b8aa0ed.js';
import { s as spacing } from './spacing-608a84f4.js';
import { l as layout } from './layout-98a901d5.js';
import { s as shadows } from './shadows-e287c7cc.js';
import { r as radius } from './radius-2ce46c77.js';
import { s as styledSystem } from './styled-system-65150b6c.js';

var theme = {
    colors: colors,
    typography: typography,
    spacing: spacing,
    layout: layout,
    shadows: shadows,
    radius: radius,
};
var theme$1 = __assign(__assign({}, theme), styledSystem);

export { theme$1 as t };
//# sourceMappingURL=index-bc225f77.js.map
